module.exports = __webpack_public_path__ + "static/media/(LH)_MG_6047_-_Pro-Natura_-_Moda_Bebe.39b316fc.jpg";